import { faEnvelope, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DialogTitle, Dialog, DialogContent, DialogActions, Button } from '@material-ui/core';
import React, { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import * as generalSelectors from '../reducer/General/selectors';
import * as generalActions from '../actions/General/generalActions'
import { IMessage } from '../reducer/General/_interfaces';

type IProps = {
    forceOpen?: boolean;
}

export const GlobalMessageModal:FC<IProps> = ({forceOpen = false}) => {
    const dispatch = useDispatch();
    const globalMessage:IMessage = useSelector(generalSelectors.getGeneralMessage);

    const [open, setOpen] = useState<boolean>(forceOpen);

    const onDismiss = () => {
        if (!globalMessage?.canDismiss) return;
        setOpen(false);
        dispatch(generalActions.resetGeneralMessage())
    }

        console.log({ open, globalMessage })
    useEffect(() => {
        console.log({ open, globalMessage })
        if (globalMessage && !open) setOpen(true);
    }, [globalMessage]);

    return (
        <Dialog
            open={open}
            onClose={onDismiss}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <DialogTitle style={{ paddingBottom: 0 }}>
                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center'
                }}>
                    <FontAwesomeIcon
                        icon={faExclamationTriangle}
                        className="dialogue-icon"
                        size="1x"
                    />
                    <label style={{ marginLeft: '0.75rem' }}>{globalMessage?.type}</label>
                </div>
            </DialogTitle>
            <DialogContent
                style={{
                    textAlign: 'center',
                    maxWidth: '51vh'
                }}
            >
                {globalMessage?.text.join(" ")}
            </DialogContent>
            <DialogActions className='dialogue-button-container'>
                {globalMessage?.canDismiss && <button
                    className="dialogue-button-submit"
                    type="button"
                    onClick={onDismiss}
                >
                        Close
                </button>}
            </DialogActions>
        </Dialog>
    )
}